import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-datepicker-dialog',
  templateUrl: './datepicker-dialog.component.html',
  styleUrls: ['./datepicker-dialog.component.scss']
})
export class DatepickerDialogComponent extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() label:string;
  @Input() dateOnly:boolean;
  @Input() selectedDate:Date;
  form: UntypedFormGroup;

  ngOnInit(): void {
    if(!this.selectedDate){
      this.selectedDate = new Date();
    }
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedDate'].value;
        this.dialog.close({ text: 'OK' , selectedDate: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedDate: [this.selectedDate, Validators.required],
    });
  }
}
